var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        "padding-top": "5px",
        width: "830px",
        "background-color": "#f5f7f7"
      }
    },
    [
      _c("div", { staticClass: "app-main-inner adjust_rate" }, [
        _c(
          "div",
          {
            staticClass: "app-main-inner-row",
            staticStyle: { padding: "0", "margin-left": "10px" }
          },
          [
            _c("span", { staticStyle: { "font-size": "16px" } }, [
              _vm._v(_vm._s(_vm.IssueOfTheYear))
            ]),
            _c(
              "span",
              { staticStyle: { "font-size": "13px", "margin-left": "15px" } },
              [_vm._v(_vm._s(_vm.adjustRateAccountingDocumentNo))]
            )
          ]
        ),
        _c(
          "div",
          {
            staticClass: "app-main-inner-row",
            staticStyle: { padding: "0", "margin-left": "10px" }
          },
          [
            _c(
              "el-form",
              { attrs: { inline: true, "label-position": "left" } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "el-form-item-documentDate",
                    attrs: { label: _vm.$t("CargoMsg.Cargo_ProofDateP") }
                  },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "date",
                        clearable: false,
                        "value-format": "yyyy-MM-dd",
                        editable: false,
                        no: "1"
                      },
                      model: {
                        value: _vm.documentDate,
                        callback: function($$v) {
                          _vm.documentDate = $$v
                        },
                        expression: "documentDate"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "el-form-item-prefix",
                    staticStyle: {
                      "word-break": "break-all",
                      "white-space": "normal"
                    },
                    attrs: { label: _vm.$t("CargoMsg.Cargo_VoucherLetter") }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { no: "2" },
                        model: {
                          value: _vm.prefix,
                          callback: function($$v) {
                            _vm.prefix = $$v
                          },
                          expression: "prefix"
                        }
                      },
                      _vm._l(_vm.prefixList, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "el-form-item-documentNo",
                    attrs: { label: _vm.$t("CargoMsg.Cargo_VoucherNo") }
                  },
                  [
                    _c("el-input-number", {
                      attrs: { min: 0, precision: 0, controls: false, no: "3" },
                      on: {
                        blur: function(e) {
                          if (e.target.value <= 0) {
                            _vm.documentNo = undefined
                          }
                        }
                      },
                      model: {
                        value: _vm.documentNo,
                        callback: function($$v) {
                          _vm.documentNo = $$v
                        },
                        expression: "documentNo"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "el-form-item-summary",
                    attrs: { label: _vm.$t("CargoMsg.Cargo_VoucherAbstract") }
                  },
                  [
                    _c("el-input", {
                      attrs: { no: "4" },
                      model: {
                        value: _vm.summary,
                        callback: function($$v) {
                          _vm.summary = $$v
                        },
                        expression: "summary"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "el-form-item-accountTitle",
                    attrs: { label: _vm.$t("CargoMsg.Cargo_AccountTitle") }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: true, no: "5" },
                        model: {
                          value: _vm.adjustAccountTitle,
                          callback: function($$v) {
                            _vm.adjustAccountTitle = $$v
                          },
                          expression: "adjustAccountTitle"
                        }
                      },
                      _vm._l(_vm.accountTitleCollection, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: _vm.accountTitleLabelFun(item),
                            value: item.accountTitle
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "app-main-inner-row",
            staticStyle: { padding: "0", "margin-left": "10px" }
          },
          [
            _c("span", { staticStyle: { "font-size": "14px" } }, [
              _vm._v(
                _vm._s(_vm.$t("CargoMsg.Cargo_ExchangeRateAdjustmentTable"))
              )
            ])
          ]
        ),
        _c(
          "div",
          {
            staticClass: "app-main-inner-row row-grid",
            staticStyle: {
              padding: "0",
              "margin-left": "10px",
              height: "260px",
              width: "805px"
            }
          },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "show-side-bar": false,
                "grid-params": _vm.gridParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData,
                no: "6"
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "app-main-inner-row",
            staticStyle: {
              "margin-left": "10px",
              "margin-bottom": "10px",
              "flex-direction": "row-reverse"
            }
          },
          [
            _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  disabled: !_vm.hasNextRates || _vm.isProcessing,
                  no: "7"
                },
                on: { click: _vm.adjustRateGeneratorBtnClickHandler }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CreateVoucher")))]
            )
          ],
          1
        )
      ]),
      _c("div", {
        staticStyle: { height: "100%", "background-color": "#e2e8f3" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }